import React, { forwardRef, useEffect, useState } from 'react'
import { HiChevronRight } from 'react-icons/hi2'
import BottomSheet from 'components/ui/BottomSheet/BottomSheet'

/**
 * Mobile renderer for the AI menu. Drives a navigation stack over the SAME
 * `contextMenuConfig` tree the desktop popover uses: tapping a branch drills in,
 * tapping a leaf opens its tool, and the sheet header's back button pops a level.
 * Presentation only — every tool keeps the props baked into its config node.
 */
const MobileMenu = forwardRef(({ isOpen, onClose, config, fullText }, ref) => {

    const [stack, setStack] = useState([])

    // Always reopen at the root.
    useEffect(() => { setStack([]) }, [isOpen])

    const current = stack[stack.length - 1]
    const isToolView = !!current?.clickComponent
    const items = isToolView ? null : (current?.items || config)

    const title = current?.title ?? 'AI Tools'
    const onBack = stack.length ? () => setStack((s) => s.slice(0, -1)) : undefined

    const tapItem = (item) => {
        if ((item?.items && item.items.length) || item?.clickComponent) {
            setStack((s) => [...s, item])
        }
    }

    return (
        <BottomSheet ref={ref} isOpen={isOpen} onClose={onClose} title={title} onBack={onBack}>
            {isToolView ? (
                <div className="p-4">{current.clickComponent}</div>
            ) : (
                <div className="py-1.5">
                    {items?.filter(Boolean).map((item, key) => {
                        if (item?.type === 'divider') {
                            return (
                                <div
                                    key={key}
                                    className="px-4 pb-1.5 pt-4 text-[11px] font-bold uppercase tracking-wide text-tertiary-400 dark:text-gray-400"
                                >
                                    {item.title}
                                </div>
                            )
                        }
                        const disabled = item?.isModifier && !fullText?.trim()
                        const hasChildren = (item?.items && item.items.length > 0) || !!item?.clickComponent
                        return (
                            <button
                                key={key}
                                type="button"
                                disabled={disabled}
                                onClick={() => !disabled && hasChildren && tapItem(item)}
                                className={`flex min-h-[3.25rem] w-full items-center gap-3 px-4 text-left text-[15px] text-tertiary-800 transition-colors active:bg-primary-600/10 dark:text-white ${disabled ? 'opacity-40' : ''}`}
                            >
                                {item?.icon && (
                                    <span className="flex w-6 shrink-0 items-center justify-center text-xl text-primary-600">
                                        {item.icon}
                                    </span>
                                )}
                                <span className="flex-1">{item.title}</span>
                                {item?.items?.length > 0 && (
                                    <HiChevronRight className="shrink-0 text-lg text-tertiary-400 dark:text-gray-400" />
                                )}
                            </button>
                        )
                    })}
                </div>
            )}
        </BottomSheet>
    )
})

export default MobileMenu
